const { PublicKeyCredential } = window;

export default {
  create: (optionsFromServer) => {
    const publicKey = PublicKeyCredential.parseCreationOptionsFromJSON(optionsFromServer);

    return navigator.credentials.create({ publicKey });
  },
  get: async (optionsFromServer) => {
    const publicKey = PublicKeyCredential.parseRequestOptionsFromJSON(optionsFromServer);

    return navigator.credentials.get({ publicKey });
  },
  /*
    NOTE: availability of the `PublicKeyCredential.parseCreationOptionsFromJSON`
    function in the browser indicates that WebAuthn is supported by the user's
    browser.
  */
  supported: () => (
    !!PublicKeyCredential?.parseCreationOptionsFromJSON
  )
}
